import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeadingSection from "../../../../common/pageheading/PageHeadingSection";
import BreadCrum from "../../../../common/BreadCrum/BreadCrum";
import CommonTable from "../../../../common/table/ComonTable";
import SearchBar from "../../../../common/formfields/SearchBar";
import CustomSelect from "../../../../common/formfields/CustomSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

// Dummy data mirroring the screenshot
const DUMMY_TENANTS = [
    { isGroup: true, floorName: "First Floor", id: "group_floor_1" },
    {
        id: "101",
        companyName: "Centrum IT Services",
        contactPerson: "Rahul Sharma",
        employees: 120,
        allocSlots: 30,
        regVehicles: 28,
        actVehicles: 25,
        visitorSlots: "5 Vehicles",
        status: "Active",
        parentFloorId: "group_floor_1",
    },
    {
        id: "102",
        companyName: "Apex Health Clinic",
        contactPerson: "Priya Patel",
        employees: 95,
        allocSlots: 25,
        regVehicles: 22,
        actVehicles: 20,
        visitorSlots: "6 Vehicles",
        status: "Active",
        parentFloorId: "group_floor_1",
    },
    {
        id: "103",
        companyName: "Deloitte Consulting",
        contactPerson: "Amit Mehta",
        employees: 60,
        allocSlots: 18,
        regVehicles: 15,
        actVehicles: 14,
        visitorSlots: "3 Vehicles",
        status: "Active",
        parentFloorId: "group_floor_1",
    },
    {
        id: "104",
        companyName: "Zentechinfo Solution",
        contactPerson: "Neha Shah",
        employees: 35,
        allocSlots: 12,
        regVehicles: 10,
        actVehicles: 9,
        visitorSlots: "5 Vehicles",
        status: "Active",
        parentFloorId: "group_floor_1",
    }
];

const TABLE_HEADERS = [
    { key: "id", label: "UNIT NO." },
    { key: "companyName", label: "COMPANY NAME" },
    { key: "contactPerson", label: "CONTACT PERSON" },
    { key: "employees", label: "EMPLOYEES" },
    { key: "allocSlots", label: "ALLOC. SLOTS" },
    { key: "regVehicles", label: "REG. VEHICLES" },
    { key: "actVehicles", label: "ACT. VEHICLES" },
    { key: "visitorSlots", label: "VISITOR SLOTS" },
    { key: "status", label: "STATUS" },
    { key: "custom_actions", label: "ACTIONS" },
];

const VehicleRegistry = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedOrg, setSelectedOrg] = useState("");

    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 128,
        totalPages: 13
    });

    const handlePageChange = (page) => {
        setPagination(prev => ({ ...prev, pageNumber: page }));
    };

    const handleLimitChange = (e) => {
        setPagination(prev => ({ ...prev, pageSize: parseInt(e.target.value), pageNumber: 1 }));
    };

    const breadcrumbs = [
        { label: "Parking Management", link: "/zentres/parking-management/operations" },
        { label: "Vehicle Registry" }
    ];

    const orgOptions = [
        { label: "All Organizations", value: "" },
        { label: "Centrum IT Services", value: "Centrum IT Services" },
        { label: "Apex Health Clinic", value: "Apex Health Clinic" },
    ];

    const handleSearch = (query) => {
        setSearchQuery(query);
    };

    const renderCell = (key, row) => {
        if (key === "visitorSlots") {
            return (
                <span className="px-3 py-1 bg-blue-50 dark:bg-actionitembg text-blue-600 dark:text-blue-400 font-semibold text-[11px] rounded-full">
                    {row[key]}
                </span>
            );
        }
        if (key === "status") {
            return (
                <span className="px-3 py-1 bg-green-50 dark:bg-green-500/10 text-green-600 dark:text-green-400 font-semibold text-[11px] rounded-full">
                    {row[key]}
                </span>
            );
        }
        if (key === "custom_actions") {
            return (
                <button
                    onClick={() => navigate(`/zentres/parking-management/vehicle-registry/${row.id}`)}
                    className="text-blue-600 dark:text-blue-400 hover:underline font-semibold text-xs flex flex-col items-center justify-center leading-tight"
                >
                    <span>View</span>
                    <span>Vehicles</span>
                </button>
            );
        }
        if (["id", "employees", "allocSlots", "regVehicles", "actVehicles"].includes(key)) {
            return <span className="text-xs font-medium text-gray-500 dark:text-textsecondary">{row[key]}</span>;
        }
        return <span className="text-xs font-semibold text-gray-800 dark:text-textprimary tracking-tight">{row[key]}</span>;
    };

    const renderGroupRow = (row, { isExpanded, toggleGroup }) => {
        return (
            <td colSpan={TABLE_HEADERS.length} className="px-4 py-3 bg-gray-50 dark:bg-dashboardbg cursor-pointer" onClick={toggleGroup}>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-red-600 dark:text-red-500">
                        {row.floorName}
                    </span>
                    <span className="text-gray-400 text-xs font-bold">
                        {isExpanded ? "−" : "+"}
                    </span>
                </div>
            </td>
        );
    };

    const headerAction = (
        <div className="flex items-center gap-3">
            <div className="w-[220px]">
                <SearchBar
                    onSearch={handleSearch}
                    placeholder="Search units..."
                />
            </div>
            <div className="w-[180px]">
                <CustomSelect
                    options={orgOptions}
                    value={selectedOrg}
                    onChange={setSelectedOrg}
                    placeholder="All Organizations"
                />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-gray-100 dark:bg-actionitembg text-gray-700 dark:text-textprimary rounded-lg text-sm font-semibold hover:bg-gray-200 dark:hover:opacity-85 transition-colors">
                <FontAwesomeIcon icon={faDownload} className="text-xs" />
                Export
            </button>
        </div>
    );

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-4 pt-4">
            <BreadCrum items={breadcrumbs} />

            <PageHeadingSection
                mainHeading="Tenant Quotas & Fleet Units"
                subHeading="Select a tenant unit to inspect its registered vehicle fleet, credentials, and slot allocations."
            />


            {/* Main Table */}
            <div className="shrink-0 flex-1 flex flex-col">
                <CommonTable
                    tableHeading="Tenant Units List"
                    headers={TABLE_HEADERS}
                    data={DUMMY_TENANTS}
                    renderCell={renderCell}
                    headerAction={headerAction}
                    collapsible={true}
                    defaultExpanded={true}
                    isGroupRow={(row) => row.isGroup}
                    renderGroupRow={renderGroupRow}
                    getGroupId={(row) => row.id}
                    getGroupOfRow={(row) => row.parentFloorId}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onLimitChange={handleLimitChange}
                />
            </div>
        </div>
    );
};

export default VehicleRegistry;
